import type { CountryItem } from './types';

export const countries: CountryItem[] = [
  { value: '+93', label: 'Afghanistan (افغانستان)', iso2: 'af' },
  { value: '+355', label: 'Albania (Shqipëria)', iso2: 'al' },
  { value: '+213', label: 'Algeria (الجزائر)', iso2: 'dz' },
  { value: '+376', label: 'Andorra (AD)', iso2: 'ad' },
  { value: '+244', label: 'Angola (AO)', iso2: 'ao' },
  { value: '+54', label: 'Argentina (AR)', iso2: 'ar' },
  { value: '+374', label: 'Armenia (Հայաստան)', iso2: 'am' },
  { value: '+61', label: 'Australia (AU)', iso2: 'au' },
  { value: '+43', label: 'Austria (Österreich)', iso2: 'at' },
  { value: '+994', label: 'Azerbaijan (Azərbaycan)', iso2: 'az' },
  { value: '+1-242', label: 'Bahamas (BS)', iso2: 'bs' },
  { value: '+973', label: 'Bahrain (البحرين)', iso2: 'bh' },
  { value: '+880', label: 'Bangladesh (বাংলাদেশ)', iso2: 'bd' },
  { value: '+375', label: 'Belarus (Беларусь)', iso2: 'by' },
  { value: '+32', label: 'Belgium (België)', iso2: 'be' },
  { value: '+501', label: 'Belize (BZ)', iso2: 'bz' },
  { value: '+229', label: 'Benin (Bénin)', iso2: 'bj' },
  { value: '+975', label: 'Bhutan (འབྲུག)', iso2: 'bt' },
  { value: '+591', label: 'Bolivia (BO)', iso2: 'bo' },
  {
    value: '+387',
    label: 'Bosnia and Herzegovina (Bosna i Hercegovina)',
    iso2: 'ba',
  },
  { value: '+267', label: 'Botswana (BW)', iso2: 'bw' },
  { value: '+55', label: 'Brazil (Brasil)', iso2: 'br' },
  { value: '+673', label: 'Brunei (BN)', iso2: 'bn' },
  { value: '+359', label: 'Bulgaria (България)', iso2: 'bg' },
  { value: '+226', label: 'Burkina Faso (BF)', iso2: 'bf' },
  { value: '+257', label: 'Burundi (BI)', iso2: 'bi' },
  { value: '+855', label: 'Cambodia (កម្ពុជា)', iso2: 'kh' },
  { value: '+237', label: 'Cameroon (Cameroun)', iso2: 'cm' },
  { value: '+1', label: 'Canada (CA)', iso2: 'ca' },
  { value: '+56', label: 'Chile (CL)', iso2: 'cl' },
  { value: '+86', label: 'China (中国)', iso2: 'cn' },
  { value: '+57', label: 'Colombia (CO)', iso2: 'co' },
  { value: '+506', label: 'Costa Rica (Costa Rica)', iso2: 'cr' },
  { value: '+385', label: 'Croatia (Hrvatska)', iso2: 'hr' },
  { value: '+53', label: 'Cuba (CU)', iso2: 'cu' },
  { value: '+357', label: 'Cyprus (Κύπρος)', iso2: 'cy' },
  { value: '+420', label: 'Czech Republic (Česko)', iso2: 'cz' },
  { value: '+45', label: 'Denmark (Danmark)', iso2: 'dk' },
  {
    value: '+1-809',
    label: 'Dominican Republic (República Dominicana)',
    iso2: 'do',
  },
  { value: '+593', label: 'Ecuador (EC)', iso2: 'ec' },
  { value: '+20', label: 'Egypt (مصر)', iso2: 'eg' },
  { value: '+503', label: 'El Salvador (SV)', iso2: 'sv' },
  { value: '+372', label: 'Estonia (Eesti)', iso2: 'ee' },
  { value: '+251', label: 'Ethiopia (ኢትዮጵያ)', iso2: 'et' },
  { value: '+358', label: 'Finland (Suomi)', iso2: 'fi' },
  { value: '+33', label: 'France (FR)', iso2: 'fr' },
  { value: '+49', label: 'Germany (Deutschland)', iso2: 'de' },
  { value: '+233', label: 'Ghana (GH)', iso2: 'gh' },
  { value: '+30', label: 'Greece (Ελλάδα)', iso2: 'gr' },
  { value: '+502', label: 'Guatemala (GT)', iso2: 'gt' },
  { value: '+504', label: 'Honduras (HN)', iso2: 'hn' },
  { value: '+852', label: 'Hong Kong (香港)', iso2: 'hk' },
  { value: '+36', label: 'Hungary (Magyarország)', iso2: 'hu' },
  { value: '+354', label: 'Iceland (Ísland)', iso2: 'is' },
  { value: '+91', label: 'India (भारत)', iso2: 'in' },
  { value: '+62', label: 'Indonesia (ID)', iso2: 'id' },
  { value: '+98', label: 'Iran (ایران)', iso2: 'ir' },
  { value: '+964', label: 'Iraq (العراق)', iso2: 'iq' },
  { value: '+353', label: 'Ireland (Éire)', iso2: 'ie' },
  { value: '+972', label: 'Israel (ישראל)', iso2: 'il' },
  { value: '+39', label: 'Italy (Italia)', iso2: 'it' },
  { value: '+1-876', label: 'Jamaica (JM)', iso2: 'jm' },
  { value: '+81', label: 'Japan (日本)', iso2: 'jp' },
  { value: '+962', label: 'Jordan (الأردن)', iso2: 'jo' },
  { value: '+254', label: 'Kenya (KE)', iso2: 'ke' },
  { value: '+965', label: 'Kuwait (الكويت)', iso2: 'kw' },
  { value: '+371', label: 'Latvia (Latvija)', iso2: 'lv' },
  { value: '+961', label: 'Lebanon (لبنان)', iso2: 'lb' },
  { value: '+370', label: 'Lithuania (Lietuva)', iso2: 'lt' },
  { value: '+352', label: 'Luxembourg (Lëtzebuerg)', iso2: 'lu' },
  { value: '+60', label: 'Malaysia (MY)', iso2: 'my' },
  { value: '+52', label: 'Mexico (México)', iso2: 'mx' },
  { value: '+212', label: 'Morocco (المغرب)', iso2: 'ma' },
  { value: '+31', label: 'Netherlands (Nederland)', iso2: 'nl' },
  { value: '+64', label: 'New Zealand (Aotearoa)', iso2: 'nz' },
  { value: '+234', label: 'Nigeria (NG)', iso2: 'ng' },
  { value: '+47', label: 'Norway (Norge)', iso2: 'no' },
  { value: '+92', label: 'Pakistan (پاکستان)', iso2: 'pk' },
  { value: '+507', label: 'Panama (Panamá)', iso2: 'pa' },
  { value: '+595', label: 'Paraguay (Paraguay)', iso2: 'py' },
  { value: '+51', label: 'Peru (Perú)', iso2: 'pe' },
  { value: '+63', label: 'Philippines (Pilipinas)', iso2: 'ph' },
  { value: '+48', label: 'Poland (Polska)', iso2: 'pl' },
  { value: '+351', label: 'Portugal (PT)', iso2: 'pt' },
  { value: '+974', label: 'Qatar (قطر)', iso2: 'qa' },
  { value: '+40', label: 'Romania (România)', iso2: 'ro' },
  { value: '+7', label: 'Russia (Россия)', iso2: 'ru' },
  { value: '+966', label: 'Saudi Arabia (السعودية)', iso2: 'sa' },
  { value: '+381', label: 'Serbia (Србија)', iso2: 'rs' },
  { value: '+65', label: 'Singapore (SG)', iso2: 'sg' },
  { value: '+421', label: 'Slovakia (Slovensko)', iso2: 'sk' },
  { value: '+386', label: 'Slovenia (Slovenija)', iso2: 'si' },
  { value: '+27', label: 'South Africa (ZA)', iso2: 'za' },
  { value: '+82', label: 'South Korea (한국)', iso2: 'kr' },
  { value: '+34', label: 'Spain (España)', iso2: 'es' },
  { value: '+94', label: 'Sri Lanka (ශ්‍රී ලංකාව)', iso2: 'lk' },
  { value: '+46', label: 'Sweden (Sverige)', iso2: 'se' },
  { value: '+41', label: 'Switzerland (Schweiz)', iso2: 'ch' },
  { value: '+66', label: 'Thailand (ประเทศไทย)', iso2: 'th' },
  { value: '+90', label: 'Turkey (Türkiye)', iso2: 'tr' },
  { value: '+380', label: 'Ukraine (Україна)', iso2: 'ua' },
  {
    value: '+971',
    label: 'United Arab Emirates (الإمارات)',
    iso2: 'ae',
  },
  { value: '+44', label: 'United Kingdom (GB)', iso2: 'gb' },
  { value: '+1', label: 'United States (USA)', iso2: 'us' },
  { value: '+598', label: 'Uruguay (UY)', iso2: 'uy' },
  { value: '+58', label: 'Venezuela (VE)', iso2: 've' },
  { value: '+84', label: 'Vietnam (Việt Nam)', iso2: 'vn' },
  { value: '+260', label: 'Zambia (ZM)', iso2: 'zm' },
  { value: '+263', label: 'Zimbabwe (ZW)', iso2: 'zw' },
];
